import myActivitiesActionTypes from "./MyActivitiesActionTypes.js";
class MyActivitiesActions {
  setUserContext(userContext) {
    return {
      type: myActivitiesActionTypes.SET_USER_CONTEXT,
      payload: userContext
    };
  }
  setPartialUserContext(userContext) {
    return {
      type: myActivitiesActionTypes.SET_PARTIAL_USER_CONTEXT,
      payload: userContext
    };
  }
  getMyActivitiesExps(payload, queryType) {
    return {
      type: myActivitiesActionTypes.GET_MY_EXPS,
      payload: {
        address: payload,
        queryType
      }
    };
  }
  updateAllExpsAction(queryType, payload) {
    return {
      type: myActivitiesActionTypes.UPDATE_MY_EXPS,
      payload: {
        data: payload,
        queryType
      }
    };
  }
  fetchScorecardsAction(queryType, payload) {
    return {
      type: myActivitiesActionTypes.FETCH_SCORE_CARDS,
      payload,
      queryType
    };
  }
  getAllScoreCardsAction(queryType, payload) {
    return {
      type: myActivitiesActionTypes.UPDATE_SCORE_CARDS,
      payload: {
        data: payload,
        queryType
      }
    };
  }
  fetchStatusAction(queryType, payload) {
    return {
      type: myActivitiesActionTypes.FETCH_STATUS,
      payload,
      queryType
    };
  }
  updateMyActivitiesStatusData(queryType, payload) {
    return {
      type: myActivitiesActionTypes.UPDATE_STATUS_DATA,
      payload: {
        data: payload,
        queryType
      }
    };
  }
}
const MyActivitiesActions$1 = new MyActivitiesActions();
export {
  MyActivitiesActions,
  MyActivitiesActions$1 as default
};
//# sourceMappingURL=MyActivitiesActions.js.map
